<div>
    <v-progress-linear
        v-if="isDataLoading"
        indeterminate
        absolute></v-progress-linear>
    <div class="page-content" v-else-if="token">
        <h1 class="mb-4">Please complete your data</h1>
        <p>
            So that we can clearly assign your request for careful
            processing, we ask you to complete the following data.
        </p>
        <ContactPostQualificationForm
            v-if="postQualification"
            :postQualification="postQualification"
            @submit="submit"
            :isSubmitting="isSubmitting"></ContactPostQualificationForm>
    </div>
</div>